import { AfterViewInit, Component, OnInit } from '@angular/core';
import {
  dailyPuzzledrop,
  dailypuzzlecurrentMove,
  getNextMoveFromData,
  highlightLastMove,
  highlightSquare,
  resetChess,
  updateBoard,
} from '../../../shared/functions/onDrop';
import {
  ChessboardFun,
  chessBoard,
  hintData,
} from '../../../shared/functions/chessboardMain';
import { CommonModule } from '@angular/common';
import { PuzzleService } from '../../../shared/services/puzzle.service';
import { game } from '../../../shared/functions/chess';
import { Router } from '@angular/router';
import { ChessBoard } from '../../../shared/js/chess';
import { DecryptionService } from '../../../shared/services/decryption.service';
declare let $: any;
@Component({
  selector: 'app-daily-puzzle',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './daily-puzzle.component.html',
  styleUrl: './daily-puzzle.component.scss',
})
export class DailyPuzzleComponent implements OnInit, AfterViewInit {
  dailyPuzzle: any;
  puzzleMoveLength: any;
  themes: any;
  chessboard: any;
  constructor(private dailyapi: PuzzleService, private router: Router,private decryptionApi: DecryptionService) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    $('#solveMorePuzzlesBtn').hide();
    ChessboardFun();
    resetChess();
    this.puzzleData();
  }

  puzzleData() {
    this.dailyapi.dailypuzzle().subscribe({
      next: (res) => {
        const decrypt=  this.decryptionApi.decrypt(res.payload);
        const jsondecrpt=JSON.parse(decrypt);
        this.dailyPuzzle = jsondecrpt;
        this.themes = this.dailyPuzzle.Themes.split(' ');
        game.load(this.dailyPuzzle.FEN);
        chessBoard.position(game.fen());
        this.puzzleMoveLength = this.dailyPuzzle.Moves.split(' ');
        dailyPuzzledrop(this.dailyPuzzle.Moves);
        updateBoard();

        setTimeout(() => {
          game.move(this.puzzleMoveLength[0]);
          highlightLastMove(
            this.puzzleMoveLength[0].substring(0, 2),
            this.puzzleMoveLength[0].substring(2, 4)
          );
          chessBoard.position(game.fen());
          dailypuzzlecurrentMove();
          let puzzleObj = this.puzzleMoveLength[1];
          hintData(puzzleObj);
          updateBoard();
        }, 1500);
        chessBoard.orientation(game.turn() === 'w' ? 'black' : 'white');
      },
      error: (err) => {},
    });
  }

  hintPuzzle() {
    const nextMove = getNextMoveFromData(this.dailyPuzzle.Moves);
    if (nextMove !== null) {
      const [source, target] = [nextMove.slice(0, 2), nextMove.slice(2, 4)];
      highlightSquare(source);
      highlightSquare(target);
    }
  }

  puzzleMainroute() {
    resetChess();
    this.router.navigate(['puzzle']);
  }
}
